import { Injectable } from '@angular/core';
import { Barcode } from '@capacitor-mlkit/barcode-scanning';
import gs1barcodeParser from 'gs1-barcode-parser-mod';

export type Gs1Data = {
  codeName: string;
  parsedCodeItems: { ai: string; dataTitle: string; data: string; unit: string; raw: string }[];
};

@Injectable({ providedIn: 'root' })
export class Gs1Encoder {
  public getGs1Data(barcode: Barcode): Gs1Data {
    const barcodeWithPrefix = this.getBarcodeWithPrefix(barcode);
    return gs1barcodeParser.parseBarcode(barcodeWithPrefix);
  }

  /**
   * get the barcode with prefix
   * adapted from https://github.com/gs1/gs1-syntax-engine/blob/main/src/ios/GS1%20Encoders%20App/BarcodeScannerView.swift
   * @param barcode
   * @returns barcode with prefix
   * @throws Error
   */
  private getBarcodeWithPrefix(barcode: Barcode): string {
    switch (barcode.format) {
      case 'CODE_128':
        if (barcode.rawValue.startsWith(']C1')) {
          return barcode.rawValue;
        } else {
          throw new Error('Non-GS1 Code 128, without FNC1 in first!');
        }
      case 'EAN_13':
      case 'UPC_A':
      case 'UPC_E':
        return `]E0${barcode.rawValue}`;
      case 'EAN_8':
        return `]E4${barcode.rawValue}`;
      case 'DATA_MATRIX':
        if (
          barcode.rawValue.startsWith('http://') ||
          barcode.rawValue.startsWith('HTTP://') ||
          barcode.rawValue.startsWith('https://') ||
          barcode.rawValue.startsWith('HTTPS://')
        ) {
          return `]d1${barcode.rawValue}`;
        } else if (barcode.rawValue.startsWith('\u{001d}')) {
          return `]d2${barcode.rawValue.replace('\u{001d}', '')}`;
        } else {
          throw new Error('Non-GS1 Data Matrix, without FNC1 in first!');
        }

      case 'QR_CODE':
        if (
          barcode.rawValue.startsWith('http://') ||
          barcode.rawValue.startsWith('HTTP://') ||
          barcode.rawValue.startsWith('https://') ||
          barcode.rawValue.startsWith('HTTPS://')
        ) {
          return `]Q1${barcode.rawValue}`;
        } else {
          // Best we can do is to assume GS1 format
          return `]Q3${barcode.rawValue}`;
        }

      default:
        throw new Error('Unrecognised format');
    }
  }
}
